import React from "react";

// Import reusable components
import ImageCard from "./ImageCard";

export default function ImageGrid({
  images,
  selectedImages,
  toggleImageSelection,
  setSelectedPreviewImage,
}) {
  return (
    <div className="px-6 py-6 flex flex-wrap gap-2 h-[270px] overflow-y-auto">
      {Array.isArray(images) &&
      images.filter(Boolean).map((img) => (
        <ImageCard
          key={img.instanceId}
          img={img}
          isSelected={selectedImages.includes(img.instanceId)}
          onToggle={() => toggleImageSelection(img.instanceId)}
          onPreview={() => setSelectedPreviewImage(img)}
        />
      ))}
    </div>
  );
}
